const AUTH = 'x-iss-authtoken';

function getStorage() {
  if (!fetch.__metadata__) {
    Object.defineProperty(fetch, '__metadata__', {
      value: {
        subscribers: new Set(),
        username: void 0,
        auth: void 0,
      },
    });
  }

  return fetch.__metadata__;
}

export async function request({ url: uri, method = 'GET', headers = {}, retry, asBlob, ...other }) {
  if (other.body && typeof other.body !== 'string') {
    other.body = JSON.stringify(other.body);
  }

  const res = await fetch(uri, {
    method,
    headers: {
      ...(other.body ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
      [AUTH]: getStorage().auth,
    },
    ...other,
  })
    // force fulfillment (pass error as response) - these failures are supposed to be network
    // level errors. (offline etc)
    .catch((e) => e);

  if (asBlob && res.ok) {
    return res.blob();
  }

  let body = null;

  try {
    // ok or not, the response might have a body... so read it.
    body = await res.clone().text();
  } catch {
    // no body
  }

  try {
    if (/json/i.test(res.headers.get('content-type'))) {
      body = JSON.parse(body);
    }
  } catch (e) {
    // not JSON
  }

  if (!res.ok) {
    emitFailure(res.clone ? res.clone() : res);
    throw Object.assign(new Error(res.statusText || 'Network Error'), {
      status: res.status,
      response: res,
      responseBody: body,
    });
  }

  if (res.headers.has(AUTH)) {
    const token = res.headers.get(AUTH);
    emitUpdatedToken(token);
    request.setAuthorization(token);
  }

  return body;
}

Object.defineProperties(request, {
  subscribe: {
    configurable: true,
    value: (fn) => {
      getStorage().subscribers.add(fn);
      return () => getStorage().subscribers.delete(fn);
    },
  },
  setAuthorization: {
    configurable: true,
    value: (x) => (getStorage().auth = x),
  },
  username: {
    configurable: true,
    get() {
      return getStorage().username;
    },
    set(v) {
      getStorage().username = v;
    },
  },
});

async function emit(...args) {
  for (let fn of getStorage().subscribers) {
    try {
      fn(...args);
    } catch (e) {
      /* istanbul ignore next */
      console.error('Error caught in request subscription callback:', e);
    }
  }
}

function emitFailure(resp) {
  emit('failure', resp);
}

function emitUpdatedToken(token) {
  emit('updated-token', token);
}
